import { Box, Divider, Grid } from '@mui/material'
import ProfileSectionHeader from 'components/common/ProfileSectionHeader/ProfileSectionHeader';
import useGlobalStyles from 'styles/globalStyles'
import { colors } from 'styles/colors';
import { useProfileContext } from 'context/ProfileContext';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AddReimbursementButton from '../AddReimbursementButton/AddReimbursementButton';
import ReimbursementItem from '../ReimbursementItem/ReimbursementItem';
import ReimbursementSkeleton from '../ReimbursementSkeleton/ReimbursementSkeleton';
import CustomText from 'components/common/CustomText/CustomText';
import { hexWithOpacity } from 'common/utils';

export default function Reimbursement() {
  const globalStyles = useGlobalStyles();
  const { reimbursement, isLoading, isFetching } = useProfileContext();
  const showSkeleton = isLoading && !reimbursement;

  return (
    <Box
      className={globalStyles.sectionContainer}
      sx={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box px={2}>
        <ProfileSectionHeader
          title={'Reimbursement'}
          icon={<ReceiptLongIcon sx={{ fontSize: 20, color: colors.primary }} />}
          buttons={!reimbursement ? [
            <AddReimbursementButton key='reimbursement' />
          ] : []}
        />
      </Box>

      <Divider />

      <Grid
        container
        spacing={1.5}
        p={2}
        sx={{
          flexGrow: showSkeleton || reimbursement ? 0 : 1,
          display: 'flex',
        }}
      >
        {showSkeleton ? (
          <Grid
            size={{
              xs: 12,
              lg: 6,
            }}
          >
            <ReimbursementSkeleton />
          </Grid>
        ) : reimbursement ? (
          <Grid
            size={{
              xs: 12,
              lg: 6,
            }}
          >
            <ReimbursementItem />
          </Grid>
        ) : (
          <Grid size={{ xs: 12 }}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="100%"
              textAlign="center"
              gap={2}
            >
              <Box height={100}>
                <ReceiptLongIcon
                  sx={{ fontSize: 100, color: hexWithOpacity(colors.secondary, 0.5) }}
                />
              </Box>
              <CustomText
                text='No reimbursement information added yet'
                color={colors.secondary}
              />
            </Box>
          </Grid>
        )}
      </Grid>

    </Box>
  )
}
